import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [{
    label: 'Despre Mine',
    href: 'https://project-about-me-page-374.magicpatterns.app/'
  }, {
    label: 'Terapie 1 la 1',
    href: 'https://project-wise-miso-279.magicpatterns.app/'
  }, {
    label: 'Mărturii',
    href: '#marturii'
  }, {
    label: 'Contact',
    href: 'https://project-about-me-page-391.magicpatterns.app/'
  }];
  return <nav className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-sm border-b border-cardBorder z-50" data-id="element-178">
      <div className="max-w-[1180px] mx-auto px-6 flex items-center justify-between h-16" data-id="element-179">
        {/* Logo */}
        <a href="#" className="font-serif text-xl font-medium text-magenta" data-id="element-180">
          Terapia T.P.V.
        </a>

        {/* Desktop nav + CTA */}
        <div className="hidden md:flex items-center gap-8" data-id="element-181">
          <ul className="flex items-center gap-8" data-id="element-182">
            {navItems.map((item, index) => <li key={index} data-id="element-183">
                <a href={item.href} className="text-sm font-medium text-navy hover:text-magenta transition-colors" data-id="element-184">
                  {item.label}
                </a>
              </li>)}
          </ul>
          <a href="https://wa.me/40749574631" target="_blank" rel="noopener noreferrer" className="bg-magenta text-white text-sm font-semibold rounded-full px-5 py-2 hover:bg-cyan transition-colors duration-300" data-id="element-185">
            Evaluare Cadou
          </a>
        </div>

        {/* Mobile toggle */}
        <button className="md:hidden text-navy" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-186">
          {isOpen ? <X className="w-6 h-6" data-id="element-187" /> : <Menu className="w-6 h-6" data-id="element-188" />}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-white border-t border-cardBorder" data-id="element-189">
          <ul className="flex flex-col px-6 py-4 gap-4" data-id="element-190">
            {navItems.map((item, index) => <li key={index} data-id="element-191">
                <a href={item.href} className="text-sm font-medium text-navy hover:text-magenta transition-colors" onClick={() => setIsOpen(false)} data-id="element-192">
                  {item.label}
                </a>
              </li>)}
            <li data-id="element-193">
              <a href="https://wa.me/40749574631" target="_blank" rel="noopener noreferrer" className="inline-block bg-magenta text-white text-sm font-semibold rounded-full px-5 py-2 hover:bg-cyan transition-colors duration-300" onClick={() => setIsOpen(false)} data-id="element-194">
                Evaluare Cadou
              </a>
            </li>
          </ul>
        </div>}
    </nav>;
}